import React, {createContext, useContext, useEffect, useState} from "react";
import localeRu from "../locale/ru.json";
import localeEn from "../locale/en.json";
import {useQuery} from "../../../cp/react-tools";

export const LocaleContext = createContext(null);

export const LocaleProvider = ({children}) => {
    const [name, setName] = useState('ru');
    const [locale, setLocale] = useState({});
    const query = useQuery();

    useEffect(() => {
        setName(query.get('lang') || 'ru');
    }, []);

    useEffect(() => {
        switch (name.toLowerCase()) {
            case 'ru': setLocale(localeRu); break;
            case 'en': setLocale(localeEn); break;
            default: setLocale(localeRu);
        }
    }, [name]);

    const context = {
        localeName: name,
        setLocaleName: setName,
        getLocaleAll() {
            return locale;
        },
        getLocale(key, defaultValue = null) {
            return locale[key] ? locale[key] : defaultValue;
        },
        getLocaleProperty(object, key, defaultValue = null) {
            if (!(object instanceof Object)) {
                return defaultValue;
            }
            const camelCaseKey = key + name.substring(0, 1).toUpperCase() + name.substring(1, 2).toLowerCase();
            if (object[camelCaseKey]) {
                return object[camelCaseKey];
            }
            const snakeCaseKey = key + '_' + name.toLowerCase();
            if (object[snakeCaseKey]) {
                return object[snakeCaseKey];
            }
            return defaultValue;
        }
    };

    return (
        <LocaleContext.Provider value={context}>
            {children}
        </LocaleContext.Provider>
    );
}

export const useLocaleContext = () => useContext(LocaleContext);
